import React, { FC, useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Paper, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import { SCUIMenuManagementDialog, SCUIMenuManagementMainRow } from '../../../atomic/molecules';
import { MenuQuery } from '../../../services/query';
import { OperatorQuery } from '../../../services/query';
import { useTranslation } from 'react-i18next';
import { MM } from './menuManagement.classes';
import './MenuManagement.scss';

export const MenuManagement: FC<any> = () => {
    const [searchedMenuName, setSearchedMenuName] = React.useState('');
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState<any>(null);
    const onModalEditClose = () => {
        setOpenEditModal(false);
        setSelectedRow(null);
    };
    const onModalEditOpen = (row: any) => {
        setSelectedRow(row);
        setOpenEditModal(true);
    };
    const [menuList, setMenuList] = useState<any>();
    const [menuApplicationList, setMenuApplicationList] = useState<any>();
    const [searchedMenuList, setSearchedMenuList] = useState<any>();
    const [parentMenu, setParentMenu] = useState<any>();
    const [roles, setRoles] = useState<any>();
    const [refresh, setRefresh] = useState(0);
    const { t } = useTranslation();
    const [menuWithApp, setMenuWithApp] = React.useState(1);

    const handleSelect = (e: any) => {
        setMenuWithApp(e.target.value);
    };
    const getMenuApplicationList = () => {
        let params = {
            applicationId: menuWithApp,
        };
        MenuQuery.GetMenuApplicationList(params)
            .then((res: any) => {
                if (res) {
                    let parsedData = res.data;
                    setMenuApplicationList(parsedData);
                    // setSearchedMenuList(parsedData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const getMenuList = () => {
        let params = {
            applicationId: menuWithApp,
        };
        MenuQuery.GetMenuAll(params)
            .then((res: any) => {
                if (res) {
                    let parsedData = res.menuItem;
                    setMenuList(parsedData);
                    setSearchedMenuList(parsedData);
                    setSearchedMenuName('');
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    //console.info(menuApplicationList)
    const GetRolesList = () => {
        OperatorQuery.GetRolesList()
            .then((res: any) => {
                if (res) {
                    setRoles(res.model.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const GetMenuItemsByParent = () => {
        let params = {
            applicationId: menuWithApp,
        };
        MenuQuery.GetMenuItemsByParent(params)
            .then((res: any) => {
                if (res) {
                    setParentMenu(res.model.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    useEffect(() => {
        GetRolesList();
    }, []);
    useEffect(() => {
        getMenuList();
        getMenuApplicationList();
        GetMenuItemsByParent();
    }, [refresh, menuWithApp]);
    const requestSearch = (searchedVal: any) => {
        setSearchedMenuName(searchedVal.target.value);
        const searchTerm = searchedVal.target.value.toLowerCase();

        if (!searchTerm) {
            setMenuList(searchedMenuList || []);
            return;
        }

        if (!searchedMenuList) {
            setMenuList([]);
            return;
        }

        let filteredMenu = JSON.parse(JSON.stringify(searchedMenuList))
            .map((menuItem: any) => {
                if (menuItem.items?.menuItem) {
                    const filteredSubMenu = menuItem.items.menuItem.filter(
                        (record: any) =>
                            record.text?.toLowerCase().includes(searchTerm) ||
                            record.menuDescription?.toLowerCase().includes(searchTerm) ||
                            record.menuNavigation?.toLowerCase().includes(searchTerm)
                    );

                    if (filteredSubMenu.length > 0) {
                        menuItem.items.menuItem = filteredSubMenu;
                        return menuItem;
                    }
                }
                return null;
            })
            .filter(Boolean); // null olan menüleri temizle

        setMenuList(filteredMenu);
    };
    const refreshMenu = () => {
        setRefresh((prev) => prev + 1);
    };
    return (
        <SCUIContent className={MM.page}>
            <Box className={MM.editDialog}>
                <SCUIMenuManagementDialog
                    selectedRow={selectedRow}
                    open={openEditModal}
                    onClose={onModalEditClose}
                    parent={parentMenu}
                    refresh={refreshMenu}
                    menuappList={menuApplicationList}
                    menuWithApp={menuWithApp}
                />
            </Box>
            <Grid container direction="row" className={MM.root} data-application-id={menuWithApp}>
                <Grid
                    className={MM.titleBox}
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    {' '}
                    <h1 className={`headtxt ${MM.title}`}>{t('dashboard.menuManagement')}</h1>
                </Grid>
                <Grid
                    className={MM.addBtnBox}
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        className={MM.btnAdd}
                        text={t('menuManagement.menuAdd')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => onModalEditOpen(null)}
                    />
                </Grid>
                <Grid
                    container
                    direction="row"
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    className={MM.filtersRow}
                >
                    <Grid
                        className={MM.searchBox}
                        size={{
                            xl: 6,
                            lg: 6,
                            md: 6,
                            xs: 6,
                        }}
                    >
                        <TextField
                            className={MM.inputSearch}
                            value={searchedMenuName}
                            onChange={(searchVal) => requestSearch(searchVal)}
                            fullWidth
                            placeholder={t('menuManagement.menuName')}
                        />
                    </Grid>
                    <Grid
                        className={MM.appBox}
                        size={{
                            xl: 6,
                            lg: 6,
                            md: 6,
                            xs: 6,
                        }}
                    >
                        <FormControl fullWidth sx={{ paddingLeft: 2 }} className={MM.appControl}>
                            <InputLabel id="parentMenuLabel">{t('menuManagementAll.application')}</InputLabel>
                            <Select
                                className={MM.inputAppSelect}
                                variant="outlined"
                                fullWidth
                                labelId="parentMenuLabel"
                                id="parentMenuLabel"
                                value={menuWithApp}
                                label={t('general.applicationId')}
                                //defaultValue={1}
                                onChange={(e) => handleSelect(e)}
                            >
                                {menuApplicationList &&
                                    menuApplicationList.map((parent: any) => (
                                        <MenuItem
                                            key={parent.applicationId}
                                            className={MM.appOption}
                                            data-application-id={parent.applicationId}
                                            data-application-name={parent.applicationName}
                                            value={parent.applicationId}
                                        >
                                            {parent.applicationName}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Paper sx={{ width: '100%' }} className={MM.tablePaper}>
                    <TableContainer component={Paper} className={MM.tableContainer}>
                        <Table aria-label="collapsible table" className={MM.table}>
                            <TableHead className={MM.tableHead}>
                                <TableRow key={'id'} className={MM.tableHeadRow}>
                                    <TableCell
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellExpand}`}
                                        data-column="expand"
                                    />
                                    <TableCell
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellMenu}`}
                                        data-column="menu"
                                    ></TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellOrder}`}
                                        data-column="order"
                                    >
                                        {t('general.orderSira')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellIcon}`}
                                        data-column="icon"
                                    >
                                        {t('general.icon')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellCountry}`}
                                        data-column="country"
                                    >
                                        {t('menuManagement.countryColumn')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellRole}`}
                                        data-column="role"
                                    >
                                        {t('general.role')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellDelete}`}
                                        data-column="delete"
                                    >
                                        {t('general.delete')}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={`${MM.tableHeadCell} ${MM.tableHeadCellEdit}`}
                                        data-column="edit"
                                    >
                                        {t('general.edit')}
                                    </TableCell>
                                    <TableCell align="center" className={`${MM.tableHeadCell} ${MM.tableHeadCellCopy}`} data-column="copy">
                                        {t('menuManagement.copy')}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className={MM.tableBody}>
                                {menuList?.map((row: any, index: number) => (
                                    <SCUIMenuManagementMainRow
                                        key={index}
                                        row={row}
                                        parent={parentMenu}
                                        roles={roles}
                                        refresh={refreshMenu}
                                    />
                                ))}
                                {null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
        </SCUIContent>
    );
};
